<template>
  <ul class="notice">
    <header-back
      :title="headTit"
      @back="toBack"
    />
    <div
      v-if="noticeList.length === 0 && loadingComplete"
      class="empty-pro-box"
    >
      <img :src="noDataImage">
    </div>
    <cube-loading
      v-if="initLoading"
      :size="40"
    />
    <load-more
      v-if="noticeDataList.length > 0"
      :page="page"
      :data="noticeDataList"
      :total="noticeTotal"
      @loadData="load"
    >
      <template>
        <notice-item
          v-for="(item, index) in noticeDataList"
          :id="item.id"
          :key="item.id"
          :date="item.dateFormat"
          :index="index"
          :title="item.title"
          :content="item.content"
          :inquiryid="item.inquiryid"
          :isread="item.isread === 1"
          :attribute="item.attribute"
          @change="changeStatus"
        />
      </template>
    </load-more>
  </ul>
</template>

<script type="text/ecmascript-6">
import { mapState, mapActions, mapMutations } from 'vuex'
import headerBack from '@/components/mobile/HeaderBack'
import { formatTime } from '@/pc/record/common'
import loadMore from '@/components/mobile/LoadMore'
import noticeItem from './components/NoticeCard'
import noDataImage from '@/assets/images/empty.png'
import { matchFromUrl } from './common'

const FROM_SOPURCE = 'notice'

export default {
  components: {
    loadMore,
    noticeItem,
    headerBack
  },
  data () {
    return {
      noDataImage,
      page: 1,
      initLoading: true
    }
  },
  computed: {
    ...mapState('record', ['noticeList', 'noticeTotal', 'loadingComplete']),
    ...mapState(['baseinfo']),
    noticeDataList () {
      return this.noticeList.map(item => {
        const { date, time } = formatTime(item.addtime)
        item.dateFormat = date + ' ' + time
        if (item.title === this.smartText) {
          item.content = matchFromUrl(item.content)
        }
        return item
      })
    },
    pid () {
      return this.$route.params.pid
    },
    headTit () {
      return this.$t('message["1216"]')
    },
    smartText () {
      return this.$t('message["1248"]')
    }
  },
  watch: {
    baseinfo (newVal) {
      document.title = this.$t('message["1216"]') + ' - ' + newVal.projectname + '-' + newVal.comname
    }
  },
  updated () {
    this.initLoading = false
  },
  async created () {
    await this.getNoticeData()
  },
  destroyed () {
    this.setNoticeList([])
  },
  methods: {
    ...mapActions('record', ['getNoticeData', 'updateNoticeStatus']),
    ...mapMutations('record', ['updateNoticeItem', 'setNoticeList']),
    formatTime,
    async load (result) {
      const { page } = result
      this.page = page
      await this.getNoticeData(this.page)
    },
    async changeStatus (result) {
      const { isread, id, index, title, inquiryid, attribute } = result
      const { followupid = 0, replyid = 0, commentid = 0 } = this.$toType(attribute) === 'object' ? attribute : {}
      let query = {
        type: 'inquiry-manager-all',
        from: FROM_SOPURCE,
        replyid
      }
      if (followupid) {
        query.followupid = followupid
        query.tab = 'followupReply'
      } else if (commentid) {
        query.commentid = commentid
        query.tab = 'commentReply'
      }

      if (isread) {
        this.toNoticeDetail(title, inquiryid, query)
      }
      if (!isread) {
        const chain = await this.updateNoticeStatus({ id, index })
        chain.onSuccess(res => {
          this.updateNoticeItem({ id, index })
        })
          .onNetComplete(() => {
            if (followupid) {
              this.toNoticeDetail(title, inquiryid, query)
            } else if (commentid) {
              this.toNoticeDetail(title, inquiryid, query)
            }
          })
          .fetch()
      }
    },
    toBack () {
      this.$router.push({ name: 'ProjectIndex' })
    },
    // 跳转到通知详情
    toNoticeDetail (title, inquiryid, query) {
      if (title.includes(this.$t('message["1500"]')) || title.includes(this.$t('message["251"]')) || title.includes('线索联系提醒')) {
        this.toast = this.$createToast({
          txt: this.$t('message["741"]'),
          type: 'txt'
        }).show()
      } else if (inquiryid && inquiryid !== 0 && title !== this.smartText) {
        this.$router.push({
          // path: `/project/${this.pid}/inquery/detail/${inquiryid}`,
          name: 'InqueryDetail',
          params: {
            pid: this.pid,
            inquiryId: inquiryid
          },
          query
        })
      } else {
        // console.log('万能表单')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.notice {
  height: calc(100vh);
  background: #f5f5f5;
  font-weight: bold;
  overflow: hidden;
  transform: rotate(0deg);
  .cube-scroll-wrapper {
    // max-height: 667px;
  }
  .empty-pro-box {
    width: 273px;
    margin: 130px auto 0;
    img {
      width: 273px;
      height: 205px;
    }
  }
}
</style>
